module.exports = __webpack_public_path__ + "static/media/survey.91538dd7.svg";